import { render, staticRenderFns } from "./BookingListPage.vue?vue&type=template&id=061bc07f&scoped=true&"
import script from "./BookingListPage.vue?vue&type=script&lang=js&"
export * from "./BookingListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061bc07f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061bc07f')) {
      api.createRecord('061bc07f', component.options)
    } else {
      api.reload('061bc07f', component.options)
    }
    module.hot.accept("./BookingListPage.vue?vue&type=template&id=061bc07f&scoped=true&", function () {
      api.rerender('061bc07f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/BookingListPage.vue"
export default component.exports